export interface Comic {
  id: string;
  title: string;
  genre: string;
  category: string;
  chapters: string;
  rating: number;
  status: '连载中' | '已完结';
  cover: string;
  desc: string;
  tags: string[];
}

export interface Category {
  key: string;
  name: string;
  icon: string;
  count: number;
  desc: string;
}

export interface TopicEntry {
  title: string;
  cover: string;
  desc: string;
  chapters: string;
  tags: string[];
}

export interface Topic {
  key: string;
  name: string;
  intro: string;
  items: TopicEntry[];
}

export interface Faq {
  q: string;
  a: string;
}

export interface Review {
  name: string;
  role: string;
  text: string;
  avatar: string;
}

export const siteName = '女神漫画网';

export const categories: Category[] = [
  {
    key: '女主',
    name: '女神主角漫画',
    icon: 'ri-flower-line',
    count: 128,
    desc: '以女神为核心主角，见证她从初醒到巅峰的成长与冒险。',
  },
  {
    key: '神话',
    name: '神话女神漫画',
    icon: 'ri-star-line',
    count: 96,
    desc: '取材中外神话传说，重塑经典女神的传奇故事。',
  },
  {
    key: '降临',
    name: '女神降临漫画',
    icon: 'ri-sun-line',
    count: 84,
    desc: '女神降临人间，展开与凡世的奇妙相遇与守护。',
  },
  {
    key: '养成',
    name: '女神养成漫画',
    icon: 'ri-seedling-line',
    count: 72,
    desc: '从平凡到耀眼，记录女神养成的暖心日常与羁绊。',
  },
  {
    key: '校园',
    name: '校园女神',
    icon: 'ri-graduation-cap-line',
    count: 58,
    desc: '青春校园里的女神，甜度满分的日常与恋爱故事。',
  },
  {
    key: '异界',
    name: '异界女神',
    icon: 'ri-sparkling-2-line',
    count: 41,
    desc: '穿越异界，化身女神的冒险、战斗与成长之旅。',
  },
];

export const comics: Comic[] = [
  {
    id: 'star-hymn',
    title: '星辉女神录',
    genre: '神话 · 冒险',
    category: '神话',
    chapters: '更新至 128 话',
    rating: 9.6,
    status: '连载中',
    cover: 'https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20an%20elegant%20star%20goddess%20with%20flowing%20silver%20hair%20and%20golden%20celestial%20ornaments%2C%20starry%20night%20background%2C%20dreamy%20soft%20lighting%2C%20high%20detail%2C%20portrait%20composition&width=480&height=640&seq=comic-star-hymn&orientation=portrait',
    desc: '当沉睡千年的星辉女神苏醒，她将重掌星河权柄，也将在众神与凡尘之间，写下属于自己的传奇。',
    tags: ['神话女神', '热血', '权柄觉醒'],
  },
  {
    id: 'goddess-daily',
    title: '女神的日常',
    genre: '治愈 · 日常',
    category: '养成',
    chapters: '更新至 76 话',
    rating: 9.3,
    status: '连载中',
    cover: 'https://readdy.ai/api/search-image?query=cute%20anime%20manga%20cover%20of%20a%20cheerful%20everyday%20goddess%20character%20with%20pink%20hair%20making%20sweets%20in%20a%20cozy%20pastel%20room%2C%20warm%20soft%20light%2C%20kawaii%20style%2C%20portrait%20composition&width=480&height=640&seq=comic-goddess-daily&orientation=portrait',
    desc: '放弃神位的少女下凡开了一间甜品店，用最平凡的日常，治愈每一位路过的凡人。',
    tags: ['治愈', '日常', '甜品'],
  },
  {
    id: 'moon-descend',
    title: '降临·月神',
    genre: '恋爱 · 奇幻',
    category: '降临',
    chapters: '更新至 52 话',
    rating: 9.5,
    status: '连载中',
    cover: 'https://readdy.ai/api/search-image?query=anime%20manga%20cover%20of%20a%20moon%20goddess%20descending%20from%20a%20crescent%20moon%20with%20a%20pale%20glow%2C%20elegant%20flowing%20robes%2C%20mystical%20romantic%20atmosphere%2C%20portrait%20composition&width=480&height=640&seq=comic-moon-descend&orientation=portrait',
    desc: '月神为寻找散落人间的月华降临凡世，却在灯火都市里，遇见了那个能看见她的人。',
    tags: ['女神降临', '恋爱', '都市'],
  },
  {
    id: 'goddess-plan',
    title: '女神养成计划',
    genre: '成长 · 校园',
    category: '养成',
    chapters: '已完结 108 话',
    rating: 9.1,
    status: '已完结',
    cover: 'https://readdy.ai/api/search-image?query=anime%20manga%20cover%20of%20a%20young%20girl%20transforming%20into%20a%20goddess%20with%20sparkles%20and%20floating%20petals%2C%20soft%20pink%20background%2C%20coming%20of%20age%20theme%2C%20portrait%20composition&width=480&height=640&seq=comic-goddess-plan&orientation=portrait',
    desc: '平凡少女被告知自己是神选之女，一场关乎蜕变的养成之旅就此展开。',
    tags: ['成长', '校园', '蜕变'],
  },
  {
    id: 'campus-goddess',
    title: '校园女神学园',
    genre: '校园 · 恋爱',
    category: '校园',
    chapters: '更新至 63 话',
    rating: 8.9,
    status: '连载中',
    cover: 'https://readdy.ai/api/search-image?query=school%20anime%20manga%20cover%20of%20a%20goddess%20student%20in%20a%20sailor%20uniform%20standing%20at%20a%20cherry%20blossom%20campus%20gate%2C%20bright%20cheerful%20colors%2C%20portrait%20composition&width=480&height=640&seq=comic-campus-goddess&orientation=portrait',
    desc: '隐藏身份的至高女神转学入凡间学园，一场鸡飞狗跳又甜到发腻的校园物语。',
    tags: ['校园', '恋爱', '欢喜冤家'],
  },
  {
    id: 'divine-chef',
    title: '神界厨神',
    genre: '美食 · 日常',
    category: '养成',
    chapters: '更新至 41 话',
    rating: 9.2,
    status: '连载中',
    cover: 'https://readdy.ai/api/search-image?query=anime%20manga%20cover%20of%20a%20cooking%20goddess%20in%20a%20divine%20kitchen%20with%20magical%20food%20and%20floating%20ingredients%2C%20warm%20golden%20tones%2C%20portrait%20composition&width=480&height=640&seq=comic-divine-chef&orientation=portrait',
    desc: '掌管人间味觉的厨神下凡，用一道道神级料理征服凡人的胃与心。',
    tags: ['美食', '治愈', '女神'],
  },
  {
    id: 'star-contract',
    title: '星辰女神的契约',
    genre: '奇幻 · 战斗',
    category: '异界',
    chapters: '更新至 88 话',
    rating: 9.0,
    status: '连载中',
    cover: 'https://readdy.ai/api/search-image?query=anime%20manga%20cover%20of%20a%20contracted%20star%20goddess%20with%20glowing%20constellation%20marks%20on%20her%20skin%2C%20dark%20cosmic%20background%20with%20soft%20light%2C%20fantasy%20epic%2C%20portrait%20composition&width=480&height=640&seq=comic-star-contract&orientation=portrait',
    desc: '凡人少年与星辰女神缔结契约，跨越种族与命运，共同对抗侵蚀星空的暗影。',
    tags: ['契约', '战斗', '异界'],
  },
  {
    id: 'goddess-awaken',
    title: '女神的觉醒',
    genre: '神话 · 史诗',
    category: '神话',
    chapters: '更新至 95 话',
    rating: 9.4,
    status: '连载中',
    cover: 'https://readdy.ai/api/search-image?query=anime%20manga%20cover%20of%20a%20goddess%20awakening%20with%20radiant%20wings%20of%20light%20and%20glowing%20energy%2C%20epic%20dramatic%20pose%2C%20luminous%20background%2C%20portrait%20composition&width=480&height=640&seq=comic-goddess-awaken&orientation=portrait',
    desc: '当世界法则崩塌，沉睡的创世女神于废墟中觉醒，展开一场守护万物的史诗之战。',
    tags: ['神话女神', '史诗', '救世'],
  },
];

export const featuredTopics: Topic[] = [
  {
    key: 'myth',
    name: '神话女神专题',
    intro: '重塑中外神话中的经典女神，在恢弘传说中重新遇见她们的身影。',
    items: [
      {
        title: '创世女娲卷',
        cover: 'https://readdy.ai/api/search-image?query=anime%20manga%20cover%20of%20a%20creation%20goddess%20shaping%20the%20world%20with%20ribbons%20of%20river%20and%20mountains%2C%20traditional%20chinese%20mythology%20style%2C%20elegant%20and%20epic%2C%20portrait%20composition&width=480&height=640&seq=feature-myth-nuwa&orientation=portrait',
        desc: '以创世神话为蓝本，讲述女神以泥与河塑造山川大地的起源篇章。',
        chapters: '全 12 话',
        tags: ['东方神话', '创世'],
      },
      {
        title: '织月嫦娥记',
        cover: 'https://readdy.ai/api/search-image?query=anime%20manga%20cover%20of%20a%20moon%20goddess%20with%20a%20jade%20rabbit%20and%20mooncakes%2C%20elegant%20chinese%20moon%20festival%20theme%2C%20soft%20warm%20light%2C%20portrait%20composition&width=480&height=640&seq=feature-myth-change&orientation=portrait',
        desc: '月亮女神与玉兔的静谧日常，把古老的传说织成一则温柔的故事。',
        chapters: '全 10 话',
        tags: ['东方神话', '治愈'],
      },
      {
        title: '海神之女',
        cover: 'https://readdy.ai/api/search-image?query=anime%20manga%20cover%20of%20an%20ocean%20goddess%20with%20flowing%20aqua%20hair%20and%20waves%2C%20sea%20pearls%2C%20underwater%20soft%20light%2C%20western%20mythology%20theme%2C%20portrait%20composition&width=480&height=640&seq=feature-myth-sea&orientation=portrait',
        desc: '海神之女在深蓝与风暴之间长大，终将接掌整片海洋的权柄。',
        chapters: '全 16 话',
        tags: ['西方神话', '海洋'],
      },
    ],
  },
  {
    key: 'descend',
    name: '女神降临专题',
    intro: '当高高在上的女神落入人间，会碰撞出怎样温暖又奇妙的故事。',
    items: [
      {
        title: '降临在人间',
        cover: 'https://readdy.ai/api/search-image?query=anime%20manga%20cover%20of%20a%20goddess%20arriving%20on%20a%20modern%20city%20rooftop%20at%20sunset%2C%20contrast%20of%20celestial%20and%20urban%2C%20warm%20golden%20light%2C%20portrait%20composition&width=480&height=640&seq=feature-descend-city&orientation=portrait',
        desc: '天界女神第一次踏上人间屋顶，在落日余晖里，重新学会如何生活。',
        chapters: '全 14 话',
        tags: ['女神降临', '都市'],
      },
      {
        title: '转生女神日常',
        cover: 'https://readdy.ai/api/search-image?query=anime%20manga%20cover%20of%20a%20reincarnated%20goddess%20in%20a%20small%20modern%20town%20cafe%2C%20wholesome%20slice%20of%20life%2C%20cozy%20warm%20atmosphere%2C%20portrait%20composition&width=480&height=640&seq=feature-descend-town&orientation=portrait',
        desc: '失去记忆的转生女神在小镇咖啡馆打工，平凡日常里藏着神明的温柔。',
        chapters: '全 18 话',
        tags: ['转生', '日常'],
      },
      {
        title: '凡人契约女神',
        cover: 'https://readdy.ai/api/search-image?query=anime%20manga%20cover%20of%20an%20ordinary%20person%20making%20a%20contract%20with%20a%20radiant%20goddess%2C%20sparkles%20and%20magic%20circle%2C%20fantasy%20romance%2C%20portrait%20composition&width=480&height=640&seq=feature-descend-contract&orientation=portrait',
        desc: '一位普通少年与降临的女神签订契约，从此命运轨迹悄然改写。',
        chapters: '全 20 话',
        tags: ['契约', '奇幻'],
      },
    ],
  },
];

export const faqs: Faq[] = [
  {
    q: '什么是「女神系漫画」？',
    a: '女神系漫画指的是以女神、神明或拥有神性力量的角色为核心主角的漫画作品，涵盖神话女神、女神主角、女神降临与养成等题材，强调角色的成长、守护与命运交织。',
  },
  {
    q: '如何在网站快速找到想看的作品？',
    a: '你可以通过顶部导航进入「分类导航」，按女神主角、神话女神、女神降临、养成、校园或异界等题材筛选；也可以在首屏搜索框直接输入作品名或关键词定位想看的漫画。',
  },
  {
    q: '网站收录的漫画是原创还是整理推荐？',
    a: '女神漫画网以整理与推荐为主，汇总公开的题材资讯与作品目录，帮助读者了解不同女神系漫画的类型和亮点。具体阅读请以作品官方渠道为准。',
  },
  {
    q: '推荐内容会定期更新吗？',
    a: '会的。我们会根据人气数据与读者反馈，定期更新热门推荐、编辑精选专题与新作速递，确保大家能看到时下值得一读的女神系作品。',
  },
  {
    q: '手机上看漫画方便吗？',
    a: '网站采用响应式设计，在电脑、平板和手机上都能流畅浏览。手机端同样支持分类筛选、专题切换与作品详情查看，阅读体验保持一致。',
  },
  {
    q: '如何反馈想看的新题材？',
    a: '如果你有特别想看的女神系题材或作品，欢迎通过页面底部的联系方式告诉我们，我们会把优质推荐纳入后续的内容整理中。',
  },
];

export const reviews: Review[] = [
  {
    name: '晚风',
    role: '漫画爱好者',
    text: '分类很清晰，一下子就能找到喜欢的神话女神题材，推荐的几部都戳中我，追更停不下来。',
    avatar: 'https://readdy.ai/api/search-image?query=soft%20anime%20avatar%20portrait%20of%20a%20young%20woman%20with%20warm%20smile%2C%20pastel%20background%2C%20clean%20flat%20illustration&width=160&height=160&seq=avatar-1&orientation=squarish',
  },
  {
    name: '拾光',
    role: '国漫读者',
    text: '编辑精选专题很有品味，神话女神那期尤其惊艳，把经典传说讲出了新意，质感很好。',
    avatar: 'https://readdy.ai/api/search-image?query=soft%20anime%20avatar%20portrait%20of%20a%20young%20man%20with%20glasses%2C%20gentle%20smile%2C%20cream%20background%2C%20clean%20flat%20illustration&width=160&height=160&seq=avatar-2&orientation=squarish',
  },
  {
    name: '星野',
    role: '日漫爱好者',
    text: '女神降临和养成题材都很全，网站看着舒服不花哨，找作品效率高，已经收藏了。',
    avatar: 'https://readdy.ai/api/search-image?query=soft%20anime%20avatar%20portrait%20of%20a%20girl%20with%20twin%20tails%2C%20cheerful%20expression%2C%20light%20pink%20background%2C%20clean%20flat%20illustration&width=160&height=160&seq=avatar-3&orientation=squarish',
  },
  {
    name: '墨羽',
    role: '资深读者',
    text: '内容梳理得很用心，每部作品都有贴心的题材标签和简介，新手也能快速入门女神系漫画。',
    avatar: 'https://readdy.ai/api/search-image?query=soft%20anime%20avatar%20portrait%20of%20a%20mature%20woman%20with%20short%20hair%2C%20warm%20confident%20smile%2C%20warm%20beige%20background%2C%20clean%20flat%20illustration&width=160&height=160&seq=avatar-4&orientation=squarish',
  },
];

export const searchSuggestions = [
  '星辉女神录',
  '降临·月神',
  '神话女神',
  '女神养成',
];